module.exports = __webpack_public_path__ + "static/media/seyfettinUslu.ae777547.jpeg";